<!-- Modal -->
@if (!isAccessGranted) {
  <div class="modal-content">
    <div class="fc_modal_body modal-body">
      <div class="btn-div">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onClose()"></button>
      </div>
      <div class="vault-auth-code">
        <h2 class="auth-title Nunito mt-2">Authentication</h2>
        <p class="auth-para">For secure access, please enter the six-digit code sent to your phone number   {{getMasked(this.myProfileService.myProfileInfo?.profile?.phoneNumber)}}</p>
        <div>
          <form>
            <div class="form-group auth-input d-flex mt-4 mb-4">
              <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="otpconfig"></ng-otp-input>
            </div>
          </form>
        </div>
        <div class="send-link text-start">
          <a class="primary_link link new-code-link text_red" (click)="getCode(true)">Send a New Code</a>
        </div>
      </div>
    </div>
  </div>
}
@if (isAccessGranted) {
  <div class="page-content">
    <div class="vault-content">
      <div class="">
        <div class="vault-auth-code-success">
          <img class="mt-3" src="/assets/images/authentication-success-icon.svg" alt="authentication success icon">
          <h3 class="h3 mt-3">Access Granted!</h3>
        </div>
      </div>
    </div>
  </div>
}

